export type IconName =
  | "close"
  | "github"
  | "linkedin"
  | "sun"
  | "moon"
  | "email";

export type IconStyle = "stroke" | "fill";

export interface IconPath {
  type: "path" | "circle" | "line" | "rect";
  d?: string;
  cx?: number;
  cy?: number;
  r?: number;
  x1?: number;
  y1?: number;
  x2?: number;
  y2?: number;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  rx?: number;
}

export interface IconDefinition {
  paths: IconPath[];
  style: IconStyle;
}

export const icons: Record<IconName, IconDefinition> = {
  close: {
    style: "stroke",
    paths: [
      { type: "line", x1: 18, y1: 6, x2: 6, y2: 18 },
      { type: "line", x1: 6, y1: 6, x2: 18, y2: 18 },
    ],
  },
  github: {
    style: "fill",
    paths: [
      {
        type: "path",
        d: "M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z",
      },
    ],
  },
  linkedin: {
    style: "fill",
    paths: [
      {
        type: "path",
        d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
      },
    ],
  },
  sun: {
    style: "stroke",
    paths: [
      { type: "circle", cx: 12, cy: 12, r: 5 },
      { type: "line", x1: 12, y1: 1, x2: 12, y2: 3 },
      { type: "line", x1: 12, y1: 21, x2: 12, y2: 23 },
      { type: "line", x1: 4.22, y1: 4.22, x2: 5.64, y2: 5.64 },
      { type: "line", x1: 18.36, y1: 18.36, x2: 19.78, y2: 19.78 },
      { type: "line", x1: 1, y1: 12, x2: 3, y2: 12 },
      { type: "line", x1: 21, y1: 12, x2: 23, y2: 12 },
      { type: "line", x1: 4.22, y1: 19.78, x2: 5.64, y2: 18.36 },
      { type: "line", x1: 18.36, y1: 5.64, x2: 19.78, y2: 4.22 },
    ],
  },
  moon: {
    style: "stroke",
    paths: [
      {
        type: "path",
        d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z",
      },
    ],
  },
  email: {
    style: "stroke",
    paths: [
      { type: "rect", x: 2, y: 4, width: 20, height: 16, rx: 2 },
      { type: "path", d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" },
    ],
  },
};
